export function createShadowRoot(element, registry, appName) {
    const shadowRoot = element.attachShadow({
        mode: "open",
        // @ts-expect-error Set custom registry for the ShadowRoot.
        customElements: registry,
    });
    const appElement = shadowRoot.appendChild(document.createElement("div"));
    appElement.setAttribute("data-app", appName);
    Object.defineProperty(appElement, "ownerDocument", { value: shadowRoot });
    /**
     * React uses appElement.ownerDocument.createElement, appElement.ownerDocument.createElementNS
     * and element.ownerDocument.createElementNS under the hood when creating elements
     * See https://github.com/facebook/react/blob/main/packages/react-dom/src/client/ReactDOMComponent.js#L370.
     * These methods are not supported on a ShadowRoot by default and therefore defined below.
     */
    Object.defineProperty(shadowRoot, "createTextNode", {
        value: document.createTextNode.bind(shadowRoot.ownerDocument),
    });
    Object.defineProperty(shadowRoot, "createElementNS", {
        value: document.createElementNS.bind(shadowRoot.ownerDocument),
    });
    /**
     * The Polyfill @webcomponents/scoped-custom-element-registry adds createElement to the ShadowRoot.
     * That is why it is not added to the shadowRoot.
     * See https://github.com/WICG/webcomponents/blob/gh-pages/proposals/Scoped-Custom-Element-Registries.md#shadowroot
     * See https://github.com/webcomponents/polyfills/blob/master/packages/scoped-custom-element-registry/src/scoped-custom-element-registry.js#L422
     * */
    // Object.defineProperty(shadow, "createElement", {value: document.createElementNS.bind(shadowRoot.ownerDocument)});
    return { appElement, shadowRoot };
}
